<div [ngClass]="{'loader-overlay': overlay, 'loader-inline': inline}">
  <div class="loader-container">
    <div class="spinner" [style.width.px]="size" [style.height.px]="size"></div>
    <p *ngIf="message" class="loader-message">{{ message }}</p>
  </div>
</div>
